import { createContext } from 'react';
import type { HeaderUser } from '../types/frontV2';

// Supplied only after AppShell has completed its existing session checks.
export const FrontSessionContext = createContext<HeaderUser | null>(null);
